const imp = () => import(/* webpackChunkName: "loadSprite_reimbursement_line"*/  "../sprite/loadSprite_reimbursement_line");
const loadMap: { [key: string]: () => Promise<any> } = {
  "Icon-Abnormal-invoice-o": imp,
  "Icon-Add-header-o": imp,
  "Icon-Ali-nail-o": imp,
  "Icon-Alipay-card-pack-o": imp,
  "Icon-All-heads-up-o": imp,
  "Icon-Batch-operation-o": imp,
  "Icon-Batch-operation-o2": imp,
  "Icon-Check-o": imp,
  "Icon-Batch-reimbursement-o": imp,
  "Icon-Corporate-payment-o": imp,
  "Icon-Corresponding-account-of-bill-item-o": imp,
  "Icon-Cost-standard-o": imp,
  "Icon-Create-manually-o": imp,
  "Icon-Ctrip-Travel-o": imp,
  "Icon-Ctrip-order-o": imp,
  "Icon-Enterprise-Didi-o": imp,
  "Icon-Inspection-record-o": imp,
  "Icon-Invoice---batch-edit-o": imp,
  "Icon-Invoice---mail-o": imp,
  "Icon-Invoice---my-o": imp,
  "Icon-Invoice-inspection-o": imp,
  "Icon-Invoice-not-checked-o": imp,
  "Icon-Invoice-photo-o": imp,
  "Icon-Invoice-recycle-bin-o": imp,
  "Icon-Invoice-statistics-o": imp,
  "Icon-Invoice-title-o": imp,
  "Icon-Invoice-to-be-reported-o": imp,
  "Icon-Jingdong-order-o": imp,
  "Icon-Invoiced-o": imp,
  "Icon-Little-e-o": imp,
  "Icon-Loan-application-o": imp,
  "Icon-Loan-records-o": imp,
  "Icon-Make-a-note-of-it-o": imp,
  "Icon-Manual-input-o": imp,
  "Icon-My-work-has-been-done-o": imp,
  "Icon-Payment-records-o": imp,
  "Icon-Reimbursement-account-maintenance-o": imp,
  "Icon-Reimbursement-of-daily-expenses-o": imp,
  "Icon-Reimbursement-records-o": imp,
  "Icon-Repayment-application-o": imp,
  "Icon-Scan-invoice-code-o": imp,
  "Icon-Set-as-default-header-o": imp,
  "Icon-Third-party-account-number-o": imp,
  "Icon-To-be-paid-o": imp,
  "Icon-To-be-reimbursed-o": imp,
  "Icon-To-be-repaid-o": imp,
  "Icon-Travel-expenses-reimbursement-o": imp,
  "Icon-Travel-in-the-same-city-o": imp,
  "Icon-Travel-pre-application-o": imp,
  "Icon-Under-approval-o": imp,
  "Icon-Valid-checked-invoice-o": imp,
  "Icon-Waiting-for-me-to-apply-o": imp,
  "Icon-Wechat-card-package-o": imp,
  "Icon-Wechat-import-o": imp,
  "Icon-Wechat-file-o": imp,
  "Icon-apply-o": imp,
  "Icon-business-o": imp,
  "Icon-community-o": imp,
  "Icon-draft-o": imp,
  "Icon-form-management-o": imp,
  "Icon-invoice-o": imp,
  "Icon-payment-history-o": imp,
  "Icon-pdf-o": imp,
  "Icon-sort02-o": imp,
  "Icon-transfer-the-possession-of-o": imp,
  "Icon-Invoice-reminder-o": imp,
  "Icon-Reimbursement-of-daily-expenses": imp,
}
export default loadMap;